import { Box } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const LoginLinks = () => {
  const classes = useStyles();
  return (
    <Box alignItems="center" display="flex" flexDirection="column" gap={2}>
      <Link className={classes.link} id="forgot-password" to="/reset">
        <FormattedMessage id="Login.forgot-password-question" />
      </Link>
      <span>
        <FormattedMessage id="Login.dont-have-account" />
        &nbsp;
        <Link className={classes.link} to="/signup">
          <FormattedMessage id="Login.dont-have-account-register" />
        </Link>
      </span>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  link: {
    color: theme.palette.primary.main,
    "&:visited, &:hover, &:focus": {
      color: theme.palette.primary.main,
    },
  },
}));

export { LoginLinks };
